import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalFooter, ModalHeader } from 'ui/modal';
import { FIELD_NAMES } from '../../constants';
import { SetDefaultLocalePayload, useProjectSettingsModalsContext } from '../../contexts';
import { StyledModalBody } from '../Styled';

const { LOCALES } = FIELD_NAMES;

export const SetDefaultLocaleModal = () => {
  const dispatch = useDispatch();
  const { modalState, hideModal } = useProjectSettingsModalsContext();
  const { setValue, getValues } = useFormContext();

  const locale = modalState?.payload as SetDefaultLocalePayload;

  const onSubmit = () => {
    try {
      /**
       *  The state for default locale is maintained via the order of the values in
       *  project.extendeProjectSettings.locales: the first item is the default.
       */
      const current = getValues(LOCALES);
      const next = [locale, ...current.filter((item: string) => item !== locale)];
      setValue(LOCALES, next, { shouldDirty: true });
      dispatch(
        addPositiveToast('Default locale was updated successfully. Remember to save your changes.'),
      );
    } catch (e) {
      dispatch(addNegativeToast('Unable to update default locale. Please try again.'));
    }
    hideModal();
  };

  if (!locale) return null;

  return (
    <Modal
      id="set-default-locale-modal"
      onClose={hideModal}
      isModalOpen={true}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>Set default locale to {locale}?</ModalHeader>
      <StyledModalBody>
        <div>
          Are you sure you want to set <b>{locale}</b> as the default locale?
        </div>
        <div>
          If the user’s locale at send time does not match any localized campaign templates, we will
          send those users the default locale instead.
        </div>
      </StyledModalBody>
      <ModalFooter onClose={hideModal}>
        <PrimaryButton onClick={onSubmit} size={BUTTON_SIZES.LARGE}>
          Set as default
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
